import { SettingsInitializer } from './settings.initializer';

export function settingsInitializerFactory(initializer: SettingsInitializer) {
  return () => initializer.load();
}
